import {AUTH} from '@/store/types'
import router from '@/router'
import security from '@/security'
import utils from '@/utils/utils'
import strings from '@/strings'
import storage from '@/utils/storage'

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    path: '',
    hostnameAdmin: [
      'admin.neowrk.com',
      // 'localhost' // Uncomment this line to access admin mode on local run
    ]
  },
  getters: {
    user(state) {
      return state.user
    },
    userId (state) {
      return state.user && state.user.profile ? state.user.profile.id : ''
    },
    userEmail (state) {
      let email = state?.user?.profile?.email

      if (email && Array.isArray(email)) {
        return email[0]
      }

      return email ? email : ''
    },
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    userName (state) {
      return state.user && state.user.profile ? state.user.profile.name : ''
    },
    role (state) {
      let roles = state.user && state.user.profile ? state.user.profile.role : ''
      let rolesList = []
      if (Array.isArray(roles)) {
        rolesList = roles
      } else {
        rolesList.push(roles)
      }
      return rolesList
    },
    isGlobalAdmin (state, getters) {
      return getters.role && getters.role.some( role => role === strings.roles.globalAdmin)

    },
    isGlobalAdminHostname (state) {
      var hostname = window.location.hostname
      for (var i in state.hostnameAdmin) {
        if (hostname. includes(state.hostnameAdmin[i])) {
          return true
        }
      }
      return false
    }
  },
  mutations: {
    [AUTH.SET_USER](state, value) {
      state.user = value
    },
    [AUTH.SET_AUTHENTICATED](state, value) {
      state.isAuthenticated = value
    }
  },
  actions: {
    signIn() {
      // Check if it is a specific route, if yes, we save this route to redirect the user to it after the login process
      const currentRoute = router.history._startLocation;

      if (currentRoute !== '/' && currentRoute !== '/login')
      {
        storage.saveToLocalStorage('directRoute',  router.history._startLocation)
      }
      
      security.signinRedirect()
    },
    async signinCallback() {
      await security.signinRedirectCallback()
      router.push('/')
    },
    async authenticate ({dispatch, getters}) {
      let user = await dispatch('getUser') // see if the user details are in local storage
      if (user) {
        if (user.expired) {
          // Se expirado efetua o login novamente
          dispatch('Global/showLoading', null, {root: true})
          dispatch('signIn')
        } else {
          dispatch('setAuthenticated', true)
          dispatch('setUser', user)


          let clientId = utils.getJwtClaim(user.access_token, 'client_desk4me_id')

          window.cx.survey('identify', {external_id_client: clientId, email: getters.userEmail});
          window.cx.survey('start', 'nps');

          window.cx.tracking('currentUser', clientId);

          window.gtag('config', process.env.VUE_APP_GT_TAG, {'user_id': utils.generateHashFromString(getters.userEmail)})

          // From singing or firts open, load initial settings
          if (router.history.current.name === 'SignIn' || !router.history.current.name) {
            await dispatch('loadInitialData', user)
          }
        }
      }
    },
    async getUser() {
      let user = await security.getUser()
      return user
    },
    async loadInitialData ({dispatch, getters, rootState, rootGetters}, user) {
      if (getters.isGlobalAdminHostname) {
        dispatch('Global/resetColor', null, {root: true})
      } else {
        let clientIdDesk4MeFromJWT = utils.getJwtClaim(user.access_token, 'client_desk4me_id')
        let clientIdFreeroomFromJWT = utils.getJwtClaim(user.access_token, 'client_freeroom_id')
        await dispatch('Global/getInitialSettings', clientIdFreeroomFromJWT ? clientIdFreeroomFromJWT : clientIdDesk4MeFromJWT, {root: true})
        let clientIdDesk4me = rootState.Global.initialSettings.workspaceId
        let clientIdFreeroom = rootState.Global.initialSettings.meetingSpaceId
        dispatch('Client/setClientId', {'desk4me': clientIdDesk4me, 'freeroom': clientIdFreeroom}, {root: true})

        let showCorporateNotice = rootState.Global.initialSettings.corporateNotice.enable

        let showTermsAlert = !rootState.Global.initialSettings?.user?.hasAcceptedTermsAndPolicy

        if (showTermsAlert) {
          dispatch('Alert/getTermsAndPolicy', true, { root: true }).then(() =>
            dispatch('Global/setBlockDialogTerms', true, { root: true })
          )
        }

        dispatch('Global/setBlockDialog', showCorporateNotice, {root: true})
      }
      router.onReady(() => {
        // Case user needs to fill the initial settings
        if(!getters.isGlobalAdminHostname && !rootGetters['Global/hasValidInitialSettings']){ 
          router.push('/organization/user/settingsInitial')
          return;
        }

        const directRoute = storage.getFromLocalStorage('directRoute')

        storage.removeFromLocalStorage('directRoute')

        if(router.currentRoute.path === '/' || router.currentRoute.path === '/signin' || getters.isGlobalAdminHostname){
          if (directRoute) {
            router.push(directRoute)
          }
          else {
            router.push(utils.getLoadingPageRoute(getters.isGlobalAdminHostname, rootGetters['Global/hasBookingFeatures'], rootGetters['Global/hasMonitoring'], rootGetters['Global/hasComfort']))
          }
        }
      })
      dispatch('Global/hideLoading', null, {root: true})
    },
    signout({dispatch}) {
      dispatch('Global/setCorporateNoticeDisplayed', false, {root: true})
      security.signoutRedirect()
    },
    setAuthenticated({commit}, auth) {
      commit(AUTH.SET_AUTHENTICATED, auth)
    },
    setUser({commit}, user) {
      commit(AUTH.SET_USER, user)
    }
    // eslint-disable-next-line no-empty-pattern
  }
}